import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useClientSession } from '@/lib/ClientSessionContext';
import { MessageCircle, ArrowUp } from 'lucide-react';

import { getNextActiveWaAdmin } from '@/utils/waRotator';

export default function FloatingWidgets() {
  const { clientUser } = useClientSession();
  const location = useLocation();
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowBackToTop(true);
      } else {
        setShowBackToTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Sembunyikan WhatsApp Sales Consultation di seluruh area portal client & internal app
  const publicMarketingRoutes = ['/', '/tentang-kami', '/produk', '/layanan', '/partner', '/pricing', '/kontak', '/artikel'];
  const isPublicLandingPage = publicMarketingRoutes.some(path => location.pathname === path || (path !== '/' && location.pathname.startsWith(path)));

  // Jika di halaman portal client (/profil-saya, /pesan-po, /pesanan, /digitalmarketing, dll) -> Sembunyikan!
  if (!isPublicLandingPage) return null;

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const openWhatsApp = () => {
    const admin = getNextActiveWaAdmin();
    const phoneNumber = admin.phone.replace(/[^0-9]/g, '');
    const text = admin.customMessageText || encodeURIComponent(`Halo PT. Satala Dermatech Essential, saya tertarik untuk konsultasi maklon kosmetik. [Ref: ${admin.refCode || '#SAT-8821'}]`);
    window.open(`https://wa.me/${phoneNumber}?text=${text}`, '_blank');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3 items-end">
      {/* WhatsApp Button */}
      <div className="group relative flex items-center justify-end">
        {/* Tooltip */}
        <div className="absolute right-full mr-3 whitespace-nowrap bg-white text-[#302621] text-xs font-bold px-3 py-1.5 rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 border border-[#E6D5B8]/50 pointer-events-none">
          Konsultasi Sekarang!
        </div>
        <button 
          onClick={openWhatsApp}
          className="w-14 h-14 bg-[#D4AF37] hover:bg-[#C99B45] text-white rounded-full flex items-center justify-center shadow-lg shadow-[#D4AF37]/30 transition-transform hover:scale-110 active:scale-95"
          aria-label="Chat via WhatsApp"
        >
          <MessageCircle className="w-7 h-7" />
        </button>
      </div>

      {/* Back to Top Button */}
      <button 
        onClick={scrollToTop}
        className={`w-12 h-12 bg-white text-[#302621] border border-[#E6D5B8] rounded-full flex items-center justify-center shadow-md hover:bg-[#F9F5EC] hover:text-[#D4AF37] transition-all duration-300 ${showBackToTop ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'}`}
        aria-label="Kembali ke atas"
      >
        <ArrowUp className="w-5 h-5" />
      </button>
    </div>
  );
}
